import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './Button.module.module.scss';

const Button = ({ label = 'Click me', color = 'black', big, onClick = () => {}, disabled, className, little, flat, children, iconClass }) => {
    const classes = classNames(s.button, s[color], { [s.big]: big, [s.little]: little, [s.flat]: flat }, className);

    return (
        <button disabled={disabled} className={classes} type="submit" onClick={onClick} data-cy='SubmitBtn' data-testid={`${label}-button`}>
            {children && <span className={classNames(s.buttonIcon, iconClass)}>{children}</span>}
            {label}
        </button>
    );
};

Button.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    big: PropTypes.bool,
    little: PropTypes.bool,
    flat: PropTypes.bool,
    color: PropTypes.oneOf(['blue', 'black', 'clear', 'clear-with-border']),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
    iconClass: PropTypes.string,
};

export default Button;
